<template>
	<div class="search-result">
		<v-data-table
			:headers="header_local"
			:items="filterResults"
			:page.sync="page"
			:items-per-page="countPerpage"
			hide-default-header
			hide-default-footer
			class="table-wrap d-print-table "
			@click:row="onRowClick"
			@update:items-per-page="onUpdateItemsPerPage"
		>
			<template v-slot:top>
				<div :class="`table-head d-print-none ${$vuetify.breakpoint.xs ?'px-4': ''} `">
					<div v-if="total_count !== 0">Showing&nbsp;&nbsp;<span>{{ (page-1) * countPerpage + 1}}-{{ page * countPerpage > total_count ? total_count : page * countPerpage }}</span>&nbsp;&nbsp;of&nbsp;&nbsp;<span>{{ total_count }}</span>&nbsp;&nbsp;Jobs</div>
					<div v-if="total_count === 0">Showing&nbsp;&nbsp;<span>{{ page * countPerpage > total_count ? total_count : page * countPerpage }}</span>&nbsp;&nbsp;of&nbsp;&nbsp;<span>{{ total_count }}</span>&nbsp;&nbsp;Jobs</div>
					<div :class="$vuetify.breakpoint.xs ? 'table-head-columns-xs': 'table-head-columns'" @click="$emit('columns')">{{ `${$vuetify.breakpoint.xs ? 'Columns': 'Show/Hide columns'}` }}</div>
				</div>
			</template>
			<template v-if="$vuetify.breakpoint.smAndUp" v-slot:header="{ props: { headers } }">
				<thead>
					<v-draggable v-model="header_local" tag="tr">
						<th v-for="item in headers" 
							:key="item.value" 
							class="header-th" 
							@mouseover="isHover = item.value"
							@mouseout="isHover = ''">
							<div class="header-item" v-if="item.showable">
								<div class="header-item-sub" >
									<div class="header-item-text">{{ item.text }}</div>
									<SortUpDown 
										class="icon icon-sort-up-down" 
										:selected="isHover === item.value" 
										:selected_color="color"
										@click="onSort(item.value, item.type)"/>
								</div>
								<v-menu offset-y nudge-left="200" >
									<template v-slot:activator="{ on, attrs }">
										<div class="icon-wrap" v-bind="attrs" v-on="on">
											<ShowSearch v-if="item.searchable"
												class="icon"  
												:selected="isHover === item.value"
												:selected_color="color" 
											/>
										</div>
									</template>
									<div class="search-box">
										<v-text-field
											placeholder="Search Title..."
											outlined
											dense
											hide-details="auto"
											color="#00AAFD" 
											:value="current_key === item.value ? searchValue : ''"
											@input="searchValue = $event"
											@click.stop
										/>
										<div class="search-box-button">
											<div @click.stop="onClean">CLEAR</div>
											<div @click="onSearch(item.value)">SEARCH</div>
										</div>
									</div>
								</v-menu>
							</div>
						</th>
					</v-draggable> 
				</thead>
			</template>
			<template v-slot:[`item.code`]="{ item }">			
				<span v-html="item.code" ></span>
			</template>
			<template v-slot:[`item.short`]="{ item }">			
				<span v-html="item.short" ></span>
			</template>
			<template v-slot:[`item.job_type`]="{ item }">			
				<span v-html="item.job_type" ></span>
			</template>
			<template v-slot:[`item.status`]="{ item }">			
				<span v-html="item.status" ></span>
			</template>
			<template v-slot:[`item.client`]="{ item }">			
				<span v-html="item.client" ></span>
			</template>
			<template v-slot:[`item.division`]="{ item }">			
				<span v-html="item.division" ></span>
			</template>
			<template v-slot:[`item.acc_exec`]="{ item }">			
				<span v-html="item.acc_exec" ></span>
			</template>
			<template v-slot:[`item.acc_dir`]="{ item }">			
				<span v-html="item.acc_dir" ></span>
			</template>
			<template v-slot:[`item.perc_quoted_billed`]="{ item }">			
				<JBPerc :class="$vuetify.breakpoint.xs ? '':'jbperc'"  :value="item.perc_quoted_billed"/>
			</template>
			<template v-slot:[`item.perc_value_billed`]="{ item }">
				<JBPerc :class="$vuetify.breakpoint.xs ? '':'jbperc'" :value="item.perc_value_billed"/>
			</template>
			<template v-slot:[`item.perc_traffic_used`]="{ item }">
				<JBPerc :class="$vuetify.breakpoint.xs ? '':'jbperc'" :value="item.perc_traffic_used"/>
			</template>
			<template v-slot:[`item.total_value`]="{ item }" >
				<div class="header-item-text text-right">
					{{ item.total_value }}
				</div>
			</template>
			<template v-slot:[`item.total_invoiced`]="{ item }" >
				<div class="header-item-text text-right">
					{{ item.total_invoiced }}
				</div>
			</template>
		</v-data-table>
		<div v-if="result_original.length !== 0" class="pagination d-print-none">
			<v-pagination
				:value="page"
				:length="getPaginationTotal()"
				:total-visible="$vuetify.breakpoint.xs ? 3: 5"
				@input="onPageChange"
				circle
			></v-pagination>
			<div class="pagination-text" :class="$vuetify.breakpoint.xs ? 'ml-0':'ml-6'">show</div>
			<div class="pagination-text-page">{{ countPerpage}}/page</div>
			<v-menu offset-y>
				<template v-slot:activator="{ on, attrs }">
					<div v-bind="attrs" v-on="on"><Down class="down"/></div>
				</template>
				<v-list>
					<v-list-item-title v-for="(pageOption, index) in pageOptions" :key="index" class="option-text" @click="onClickOption(pageOption)">
						{{pageOption}}
					</v-list-item-title>
				</v-list>
			</v-menu>
		</div>
	</div>
</template>

<script>
import SortUpDown from '@/components/icons/sort_up_down';
import ShowSearch from '@/components/icons/show_search';
import Down from '@/components/icons/down';

import JBPerc from "@/components/controls/jbperc";
import config from "@/config.js";

const FONT_COLOR='#00AAFD';

export default {
	name: 'SearchResultsNew',
	props: {
		headers: {
			type: Array,
			default: () => [],
		},
		joblists: {
			type: Array,
			default: () => [],
		},
		color: {
			type: String,
			default: '#00AAFD'
		},
		page: {
			type: Number,
			default: 0
		},
		perpage: {
			type: Number,
			default: 0
		}
	},
	components: {
		SortUpDown, ShowSearch, Down, JBPerc,
	},
	data() {
		return {
			result: [],
			result_original: [],
			header_local: this.headers.filter(head => {return head.showable}),
			sortByAscent: false,
			countPerpage: this.perpage,
			pageOptions: config.pageOptions,
			searchValue: '',
			isHover: '',
			current_key: '',
			total_count: 0,
		}
	},
	created() {
		this.result_original = this.joblists;
		this.result = this.result_original;
		this.total_count = this.result_original.length !== 0 ? this.result_original[0].total_count : 0;
	},
	methods: {
		onRowClick(row) {
			this.$router.push({ name: 'View Job', params: { id: row.id } });
		},
		onUpdateItemsPerPage(itemsPerPage) {
			this.$emit('pagination', {limit: itemsPerPage, page: this.page, total: this.total_count});
		},
		onPageChange(page) {
			this.$emit('pagination', {limit: this.countPerpage, page: page, total: this.total_count});
		},
		onSort(key, type) {
			this.sortByAscent = !this.sortByAscent;

			if (type === 'text') {
				this.sortByAscent
					? this._sort_ascent(this.result, key)
					: this._sort_descent(this.result, key);
			} else if (type === 'number' || type === 'perc') {
				this.sortByAscent
					? this._sort_ascent_number(this.result, key)
					: this._sort_descent_number(this.result, key);
			}		
		},
		onClickOption(option) {
			this.countPerpage = option;
		},
		onClean() {
			this.searchValue = '';
			this.result = this.result_original;
		},
		onSearch(key) {
			if (this.searchValue.length !== 0) {
				this.current_key = key;

				const arr_filter = this._filterKey(this.result_original, key, this.searchValue);
				const arr_replace = JSON.parse(JSON.stringify(arr_filter));

				// to hightlight the kewwords
				const regex = new RegExp(this.searchValue, 'gi');
				arr_replace.forEach(arr => {
					if ( typeof(arr[key]) === 'object' ) {
						arr[key].name = arr[key].name.replace(regex, (keyword) => {
							return `<font color="${FONT_COLOR}">${keyword}</font>`;
						});
					} else {
						arr[key] = arr[key].replace(regex, (keyword) => {
							return `<font color="${FONT_COLOR}">${keyword}</font>`;
						});
					}
				});
				this.result = arr_replace;
			} 
		},
		getPaginationTotal() {
			return Math.ceil(this.total_count / this.countPerpage);
		},
		_sort_ascent(arr, key) {
			arr.sort((a, b) => {
				// ignore upper and lowercase
				const valueA = typeof(a[key]) === 'object' ? a[key].name.toUpperCase() : a[key].toUpperCase();
				const valueB = typeof(b[key]) === 'object' ? b[key].name.toUpperCase() : b[key].toUpperCase();

				if (valueA < valueB) {
					return -1;
				}
				if (valueA > valueB) {
					return 1;
				}

				return 0;
			});
		},
		_sort_descent(arr, key) {
			arr.sort((a, b) => {
				// ignore upper and lowercase
				const valueA = typeof(a[key]) === 'object' ? a[key].name.toUpperCase() : a[key].toUpperCase();
				const valueB = typeof(b[key]) === 'object' ? b[key].name.toUpperCase() : b[key].toUpperCase();

				if (valueA > valueB) {
					return -1;
				}
				if (valueA < valueB) {
					return 1;
				}

				return 0;
			});
		},
		_sort_ascent_number(arr, key) {
			arr.sort((a, b) => {
				return a[key] - b[key];
			});
		},
		_sort_descent_number(arr, key) {
			arr.sort((a, b) => {
				return b[key] - a[key];
			});
		},
		_filterKey(arr, key, filter) {
			let fliter_Arr = [];
			const filter_UpperCase = filter.toUpperCase();
			fliter_Arr = arr.filter(a => {
				const A = typeof(a[key]) === 'object' ? a[key].name.toUpperCase() : a[key].toUpperCase();
				return A.includes(filter_UpperCase);
			});
			return fliter_Arr;
		},
		_replace(keyword) {
			return `<font color="${FONT_COLOR}">${keyword}</font>`;
		},
		_formatNumber(num) {
			let res = 0;
			if (Number.isInteger(num)) {
				const integer = num.toLocaleString();
				res = integer + '.00';
			} else {
				const num_str = Number.parseFloat(num).toFixed(2)
				const num_arr = num_str.split('.');
				const integer = Number(num_arr[0]).toLocaleString();

				if (num_arr.length > 1) {
					if (num_arr[1].length === 1) {
						res = integer + '.' + num_arr[1] + '0';
					} else {
						res = integer + '.' + num_arr[1];
					}
					
				} else {
					res = integer + '.00' ;
				}
			}
			return res;
		},
	},
	computed: {
		filterResults() {
			const filterRes = [];
			this.result.forEach(res => {
				const obj = {};
				
				this.headers.forEach(item => {
					if (item.showable) {
						let tmp = null;
						if (item.value === 'total_value') {
							const number = this._formatNumber(res['total_value']);
							tmp = `${res['currency'].symbol} ${number}`;
						} else if (item.value === 'total_invoiced') {
							const number = this._formatNumber(res['total_invoiced']);
							tmp = `${res['currency'].symbol} ${number}`
						} else {
							tmp = typeof(res[item.value]) === 'object' ? res[item.value].name : res[item.value];
						}

						obj[item.value] = tmp;	
					}
						
				});
				obj['id'] = res.id;

				filterRes.push(obj);
			})
			return filterRes;
		},
	},
	watch: {
		searchValue() {
			if (this.searchValue.length !== 0) {
				this.msg = '';
			}
		},
		headers: {
			handler() { 
				this.header_local = this.headers.filter(head => {return head.showable});
			},
			deep: true,
		},
		header_local: {
			handler() { 
				// header's oder changed, emit the value
				this.$emit('header-change', this.header_local);
			},
			deep: true,
		}
	}
}
</script>

<style lang="scss" scoped>
.search-result {
	display: flex;
	flex-flow: column nowrap;
	align-items: flex-start;
	height: 100%;
}
.progress-wrap {
	width: 100%;
	display: flex;
  flex-flow: row nowrap;
	justify-content: center;
  align-items: center;
}
.table-head {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	height: 48px;
	padding: 0 30px;
	background: #FAFAFA;
	color: #192A3E;
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 16px;
	line-height: 24px;
	border-radius: 4px 4px 0 0;
	border-bottom: 1px solid #C9C9C9;
	span {
		font-weight: bold;
	}
}
.table-head-columns {
	color: #82899B;
  text-decoration: underline;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
	&:hover {
		cursor: pointer;
	}
}
.table-head-columns-xs {
	color: #82899B;
  text-decoration: underline;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
	&:hover {
		cursor: pointer;
	}
}
.table-wrap {
	width: 100%;
}
.header-th {
	// border-right: 1px solid rgba(0, 0, 0, 0.12);
	background: #FAFAFA;
	&:hover {
		background: #EAEAEA;
		cursor: move;
	}

	// :last-child {
	// 	border-right: none;
	// }
}
.header-th:hover .icon {
	visibility: visible; 
}
.header-item {
	display: flex;
  flex-flow: row nowrap;
	justify-content: space-between;
  align-items: center;
}
.header-item-sub {
	display: flex;
  flex-flow: row nowrap;
	justify-content: flex-start;
  align-items: center;
}
.header-item-text {
	white-space: nowrap;
	text-overflow: ellipsis;
}
.icon-wrap {
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
	align-items: center;
}
.icon {
	visibility: hidden;
	width: 14px;
  height: 14px;
	&:hover {
		cursor: pointer;
	}
}
.icon-sort-up-down {
  margin-left: 6px;
}
.search-box {
	padding: 13px;
	display: flex;
	flex-flow: column nowrap;
	justify-content: center;
	align-items: center;
	background: #FFFFFF;
	border-radius: 4px;
	.search-box-button {
		margin-top: 9px;
		display: flex;
		flex-flow: row nowrap;
		justify-content: space-between;
		align-items: center;
		div {
			display: flex;
			flex-flow: row nowrap;
			justify-content: center;
			align-items: center;
			border-radius: 4px;
			padding: 0 21px;

			font-family: Roboto;
			font-style: normal;
			font-weight: 500;
			font-size: 14px;
			height: 36px;

			&:hover {
				cursor: pointer;
			}
		}
		:first-child {
			border: 1px solid rgba(25, 42, 62, 0.7);
			margin-right: 10px;
			color: rgba(25, 42, 62, 0.7);
		}
		:last-child {
			border: 1px solid #00AAFD;
			background: #00AAFD;
			color: #FFFFFF;
		}
	}
}

.pagination {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	.pagination-text {
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 12px;
		line-height: 16px;
		color: rgba(25, 42, 62, 0.5);
	}
	.pagination-text-page {
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 12px;
		line-height: 16px;
		color: #192A3E;
		margin: 0 8px;
	}
	.down {
		width: 12px;
		height: 12px;
		margin-top: 10px;
		&:hover {
			cursor: pointer;
		}
	}
	
}
.jbperc {
	padding: 0; 
	margin-left: -16px;
	width: calc(100% + 32px);
}

::v-deep {
	.option-text {
		margin: 0 4px;
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 13px;
		color: #192A3E;
		&:hover {
			cursor: pointer;
		}
	}
	.v-input {
		font-size: 12px;
		width: 100%;
	}
	// .v-data-table > .v-data-table__wrapper > table > tbody > tr > td:last-child {
	// 	padding: 0;
	// 	border-right: none;
	// }
	// .v-data-table > .v-data-table__wrapper > table > thead > tr > th:last-child {
	// 	border-right: none;
	// }

	.v-data-table {
		border: 1px solid #C9C9C9;
	}
}
.selected {
	:hover {
		cursor: pointer;
	}
}
</style>